"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMarkLabel = void 0;
var defaultMarkerConfig = {
    char: "_",
    style: {
        fontSize: "18px",
        fill: "#dedbd7",
        textShadow: "black 1px 0.5px 0px, black 0px 0px 0.03em, black 0px 0px 0.01em"
    },
    hide: false
};
var defaultMarkValueConfig = {
    formatTextValue: undefined,
    maxDecimalDigits: 2,
    style: {
        fontSize: "10px",
        fill: "#dedbd7",
        textShadow: "black 1px 0.5px 0px, black 0px 0px 0.03em, black 0px 0px 0.01em"
    },
    hide: false,
};
var defaultMarkList = [];
exports.defaultMarkLabel = {
    type: 'outer',
    hideMinMax: false,
    marks: defaultMarkList,
    valueConfig: defaultMarkValueConfig,
    markerConfig: defaultMarkerConfig
};
